// removed by extract-text-webpack-plugin
module.exports = {"main":"TripletRow-main--2CCun","title":"TripletRow-title--JMtsF","rowItemsContainer":"TripletRow-rowItemsContainer---mSnq","withBorder":"TripletRow-withBorder--1wxXe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/DataPanel/TripletRow/TripletRow.scss
// module id = 9XvQ
// module chunks = 4